import { ReactNode, useId } from 'react';
import { Form } from 'react-bootstrap';

import { Label } from 'components/base/Label';

import './Field.scss';

interface FieldProps {
  readonly label: ReactNode;
  /** Append " *" to the label. */
  readonly mandatory?: boolean;
  /** Muted guidance under the control. */
  readonly helpText?: ReactNode;
  readonly children: ReactNode;
}

/**
 * A labelled form field: a semantic `Label` above a control. Pairs with the label-less `Edit*` controls (and `Segmented`) so
 * the caller places the label rather than relying on a floating label. The control is wrapped in a `Form.Group` carrying a
 * generated `controlId`, so the nested control picks up that id from context and the `Label`'s `htmlFor` matches it.
 */
export const Field = ({ label, mandatory = false, helpText, children }: FieldProps) => {
  const id = useId();
  return (
    <div className="field">
      <Label htmlFor={id} mandatory={mandatory}>
        {label}
      </Label>
      <Form.Group controlId={id}>{children}</Form.Group>
      {helpText !== undefined && <Form.Text className="text-muted">{helpText}</Form.Text>}
    </div>
  );
};
